import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "status-check-icon",
  viewBox: "0 0 11 8"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M2.03022 3.30481C1.73727 3.01198 1.26239 3.01208 0.969561 3.30503C0.676728 3.59798 0.676825 4.07286 0.969778 4.36569L2.03022 3.30481ZM4 6.33423L3.46978 6.86467C3.76269 7.15746 4.23748 7.15741 4.53033 6.86456L4 6.33423ZM10.0303 1.36456C10.3232 1.07167 10.3232 0.596792 10.0303 0.303898C9.73744 0.0110052 9.26256 0.0110052 8.96967 0.303898L10.0303 1.36456ZM4.53033 6.86456L10.0303 1.36456L8.96967 0.303898L3.46967 5.8039L4.53033 6.86456ZM0.969778 4.36569L3.46978 6.86467L4.53022 5.80379L2.03022 3.30481L0.969778 4.36569Z" }, null, -1)
  ])))
}
export default { render: render }